import { render, staticRenderFns } from "./ConfirmGlobal.vue?vue&type=template&id=d0b2c108&"
import script from "./ConfirmGlobal.vue?vue&type=script&lang=js&"
export * from "./ConfirmGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports